import { useTranslation } from 'react-i18next';
import { useParticipantsControl } from 'features/toolbar/toolbar/controls/participants/useParticipantsControl';
import MobileMenuItem from 'features/toolbar/toolbar/mobile/MobileMenuItem';
import React from 'react';
import { MobileMenuItemWrapperProps } from 'features/toolbar/types';

const ParticipantsControlMobile = ({ onClick }: MobileMenuItemWrapperProps) => {
  const { t } = useTranslation('room');

  const {
    active,
    togglePanel,
    totalParticipants,
    icon,
    isFeatureAvailable,
    canSeeParticipantsPanel,
  } = useParticipantsControl();

  if (!isFeatureAvailable) {
    return null;
  }

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    onClick?.(event);
    togglePanel();
  };

  if (!canSeeParticipantsPanel) {
    return (
      <MobileMenuItem icon={icon} selected={active} onClick={handleClick}>
        {t('toolbar.breakout_rooms')}
      </MobileMenuItem>
    );
  }

  return (
    <MobileMenuItem
      icon={icon}
      badgeContent={totalParticipants}
      selected={active}
      onClick={handleClick}
    >
      {t('toolbar.participants')}
    </MobileMenuItem>
  );
};

export default ParticipantsControlMobile;
